export function removeElement(el) {

    if (el && el.parentNode) {
        el.parentNode.removeChild(el);
    }
    else{
        console.warn("Cannot remove element");
    }
}

export function isDefinedAndNotNull(object) {

    return object !== undefined && object !== null;
}

export function addMetaData(name, content) {

    let meta = document.createElement('meta');
    meta.name = name;
    meta.content = content;
    document.getElementsByTagName("head")[0].appendChild(meta);
}


export function includeCSSFilePromise(path, id, parent) {

    const _parent = parent || document;

    return new Promise((resolve, reject) => {

        const cssNode = document.createElement('link');
        cssNode.rel = 'stylesheet';
        cssNode.type = 'text/css';
        cssNode.href = path;
        cssNode.id = id;

        cssNode.onload = resolve;
        cssNode.onerror = reject;

        _parent.appendChild(cssNode);
    });
}

export function disableElement(element, disabled) {

    if (isDefinedAndNotNull(element)) {
        element.disabled = disabled;
        element.setAttribute("aria-disabled", disabled);
        // Remove from tab order when disabled
        if (disabled) {
            element.setAttribute("tabindex", "-1");
        } else {
            element.setAttribute("tabindex", "0");
        }
    } else {
        console.warn("Cannot disable null or undefined element");
    }
}

export function hideElement(element, hidden) {

    if (isDefinedAndNotNull(element)) {
        if (hidden) {
            element.classList.remove("show");
            element.classList.add("hide");
        } else {
            element.classList.remove("hide");
            element.classList.add("show");
        }
    }
    else{
        console.warn("Cannot hide null or undefined element");
    }
}

export function getContainer() {
    return document.querySelector("vee24-scheduler-container");
}

export function buildUri(host, uri) {
    if ("https:" === document.location.protocol) {
        return 'https://' + ((isDefinedAndNotNull(host)) ? host : '') + uri;
    } else {
        return 'http://' + ((isDefinedAndNotNull(host)) ? host : '') + uri;
    }
}

export function createStylesheetLink(path, id) {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = path;
    link.id = id;
    return link;
}

export function setIsLoading(isLoading) {
    const modalBody = getContainer().querySelector(".modal-body");
    isLoading ? modalBody.classList.add("loading"): modalBody.classList.remove("loading");
}

export function attachScript(container, script, initMethod) {
    script.addEventListener('load', initMethod, false);
    container.appendChild(script);
}

export function unsetFlex(el, val) {
    if (isDefinedAndNotNull(el)) {
        val ? el.classList.add("v24-flex-unset") : el.classList.remove("v24-flex-unset");
    }
}

/**@private
    *      * Adds a CSS Class to the International Input field to allow for dealing with specific config vs cleanslate vs client conflicts
    *@param {JSON Object} Option from Appointment Template
    *@param {DOM Element} Element to add CSS to
    *@returns true for success, false for error
    */
export function addOptionConfigToElCSS(el, value) {
    try {
        el.setAttribute("class", el.className += " " + value);
    }
    catch (error) {
        return false;
    }
    return true;
}

export function registerComponent(key, component) {
    if (!componentExists(key)) {
        window.customElements.define(key, component);
    }
}

export function componentExists(key) {
    return window.customElements.get(key);
}

export function replaceChild(element, replaceWith) {
    if (isDefinedAndNotNull(element)) {
        while (element.firstChild) {
            element.removeChild(element.firstChild);
        }
        element.appendChild(replaceWith);
    }
}

export function isCharSetUTF8() {
    return document.characterSet === 'UTF-8';
}
